import { initAccessibility } from "./accessibility";
import { initSearchModal } from "./search";

const MOBILE_MENU_QUERY = "(max-width: 1224px)";
const OPEN_MENU_EVENT = "ifag:open-menu";
const CLOSE_MENU_EVENT = "ifag:close-menu";

const initMenu = () => {
    const header = document.querySelector(".header-ifag");
    const toggleMenuBtn = document.querySelector(".header-ifag__button");
    const iconOpen = document.querySelector(".header-ifag__button__open");
    const iconClose = document.querySelector(".header-ifag__button__close");
    const nav = document.querySelector(".header-ifag__nav");
    const mainBanner = document.querySelector(".main-banner-ifag");
    const mobileMenu = window.matchMedia(MOBILE_MENU_QUERY);
    const dropdownTriggers = Array.from(document.querySelectorAll("[data-ifag-dropdown-trigger]"));

    if (!header || !toggleMenuBtn || !iconOpen || !iconClose || !nav) {
        return;
    }

    const closeDropdowns = () => {
        dropdownTriggers.forEach(trigger => {
            const dropdown = document.getElementById(trigger.getAttribute("aria-controls"));

            trigger.setAttribute("aria-expanded", "false");

            if (dropdown) {
                dropdown.hidden = true;
            }
        });
    };

    const toggleDropdown = trigger => {
        if (mobileMenu.matches) {
            closeDropdowns();
            return;
        }

        const dropdown = document.getElementById(trigger.getAttribute("aria-controls"));
        const shouldOpen = trigger.getAttribute("aria-expanded") !== "true";

        closeDropdowns();

        trigger.setAttribute("aria-expanded", String(shouldOpen));

        if (dropdown) {
            dropdown.hidden = !shouldOpen;
        }
    };

    const setMenuOpen = isOpen => {
        const shouldOpen = mobileMenu.matches && isOpen;

        nav.classList.toggle("header-ifag__nav--open", shouldOpen);
        iconOpen.classList.toggle("hidden", shouldOpen);
        iconClose.classList.toggle("hidden", !shouldOpen);
        toggleMenuBtn.setAttribute("aria-expanded", String(shouldOpen));
        toggleMenuBtn.setAttribute("aria-label", shouldOpen ? "Fechar menu" : "Abrir menu");
        document.body.classList.toggle("ifag-menu-open", shouldOpen);

        if (!shouldOpen) {
            closeDropdowns();
        }
    };

    const resetMenu = () => setMenuOpen(false);

    dropdownTriggers.forEach(trigger => {
        trigger.addEventListener("click", event => {
            event.stopPropagation();
            toggleDropdown(trigger);
        });
    });

    document.addEventListener("click", event => {
        if (!event.target.closest(".header-ifag__list__item--dropdown")) {
            closeDropdowns();
        }
    });

    toggleMenuBtn.addEventListener("click", () => {
        setMenuOpen(!nav.classList.contains("header-ifag__nav--open"));
    });
    document.addEventListener(OPEN_MENU_EVENT, () => setMenuOpen(true));
    document.addEventListener(CLOSE_MENU_EVENT, resetMenu);
    document.addEventListener("keydown", event => {
        if (event.key === "Escape") {
            closeDropdowns();
        }

        if (event.key === "Escape" && nav.classList.contains("header-ifag__nav--open")) {
            resetMenu();
            toggleMenuBtn.focus();
        }
    });

    if (mobileMenu.addEventListener) {
        mobileMenu.addEventListener("change", resetMenu);
    } else {
        mobileMenu.addListener(resetMenu);
    }

    if (mainBanner) {
        header.classList.add("header-ifag--transparent");
    }

    resetMenu();
};

if (document.querySelector(".header-ifag")) {
    initMenu();
}

initSearchModal();
initAccessibility();
